export function cleanString(string) {
  if (string) return string.trim().toUpperCase().replace("Á", "A").replace("É", "E").replace("Í", "I").replace("Ó", "O").replace("Ú", "U");
  else return "";
}
